import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getAvailableBusinessUnits() {

  try{
    const data = await axios.get(`${LEADS_ENDPOINT}/userBusinessUnits`) 
    return data.data;
  }catch(error){
      throw new Error(error)
  }
}